import { render, staticRenderFns } from "./TeamTeaser.vue?vue&type=template&id=1c187597&"
import script from "./TeamTeaser.vue?vue&type=script&lang=js&"
export * from "./TeamTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports